import * as React from 'react';
import { DefaultTheme, useTheme } from 'styled-components';
import { Breakpoint } from '@mybet/components/theme/createBreakpoints';

function getMatchMediaQuery(theme: DefaultTheme, key: Breakpoint) {
  return theme.breakpoints.up(key).replace('@media ', '');
}

export default function useMatchMedia(breakpointKey: Breakpoint) {
  const theme = useTheme();
  const mediaQuery = getMatchMediaQuery(theme, breakpointKey);

  const [matches, setMatches] = React.useState(
    typeof window !== 'undefined'
      ? window?.matchMedia(mediaQuery).matches
      : true
  );

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleChange = (e: MediaQueryListEvent) => {
        setMatches(e.matches);
      };

      const matchMedia = window.matchMedia(mediaQuery);

      try {
        matchMedia.addEventListener('change', handleChange);
        return () => matchMedia.removeEventListener('change', handleChange);
      } catch (e) {
        // NOTE: this catch is to support older versions of Safari
        matchMedia.addListener(handleChange);
        return () => matchMedia.removeListener(handleChange);
      }
    }
  }, []);

  return { matches, setMatches };
}
